import { Component } from '@theme/component';

class CompareInRangeComponent extends Component {
	connectedCallback() {
		super.connectedCallback?.();

		this.wrapper = this.querySelector('.compare-in-range__table-wrapper');
		this.prevBtn = this.querySelector('.cir-arrow--prev');
		this.nextBtn = this.querySelector('.cir-arrow--next');

		if (!this.wrapper) return;

		this.wrapper.addEventListener('scroll', () => this.updateArrows(), {
			passive: true,
		});

		// Watch for layout changes so arrows update once the table has its final width
		this._ro = new ResizeObserver(() => this.updateArrows());
		this._ro.observe(this.wrapper);

		this.updateArrows();

		if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scroll(-1));
		if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scroll(1));
	}

	disconnectedCallback() {
		super.disconnectedCallback?.();
		this._ro?.disconnect();
	}

	scroll(direction) {
		if (!this.wrapper) return;
		const featureTh = this.wrapper.querySelector(
			'.compare-in-range__th:not(.compare-in-range__th--product)',
		);
		if (!featureTh) return;
		const scrollAmount = featureTh.offsetWidth;
		this.wrapper.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
	}

	updateArrows() {
		if (!this.wrapper || !this.prevBtn || !this.nextBtn) return;
		const { scrollLeft, scrollWidth, clientWidth } = this.wrapper;
		this.prevBtn.disabled = scrollLeft <= 1;
		this.nextBtn.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
	}
}

if (!customElements.get('compare-in-range-component')) {
	customElements.define('compare-in-range-component', CompareInRangeComponent);
}
